import http from "@/utils/http";
import { baseUrl } from "@/utils/config";
import { get, post } from "@/utils/http";

export const baseUrlApi = (url) => process.env.NODE_ENV === "development" ? `/api/${url}` : `${baseUrl}/api/${url}`;


export const user = {
  /**
   * 手机验证码登录
   */
  getCaptcha(data) {
    return http.post(baseUrlApi('sms/send'), data)
  }, /**
     * 账号密码登录
     */
  mobileLogin(data) {
    return http.post(baseUrlApi('user/mobilelogin'), data)
  }, /**
     * 用户手机账号登录
     */
  accountLogin(data) {
    return http.post(baseUrlApi('user/login'), data)
  }, /**
     * 获取用户信息信息
     */
  getUserInfo() {
    return http.post(baseUrlApi('user/getUserinfo'))
  }, /**
     * 用户认证
     */
  userAuth(data) {
    return http.post(baseUrlApi('shop/auth/aliPersonFaceAuth'), data)
  }, /**
     * 主动获取查询结果
     */
  getAuth(outer_order_no) {
    return http.get(baseUrlApi('shop/auth/aliPersonFaceQuery?outer_order_no=' + outer_order_no))
  }, /**
     * 退出
     * @returns
     */
  logout() {
    return http.post(baseUrlApi('user/logout'))
  }, /**
     *
     * @param {修改密码} data
     * @returns
     */
  resetPwd(data) {
    return http.post(baseUrlApi('user/resetPwd'), data)
  }, changeMobile(data) {
    return http.post(baseUrlApi('user/changemobile'), data)
  }


}

export const home = {
  index() {
    return http.get(baseUrlApi('home/config'))
  }
}

export const token = {
  check() {
    return http.post(baseUrlApi('Token/check'))
  }

}


export const service = {
  submitCustomization(data) {
    return http.post(baseUrlApi('enterprise_service/submitCustomization'), data)
  }, getAreaList(data) {
    return http.post(baseUrlApi('enterprise_service/getAreaList'), data)
  }, submitProxyPool(data) {
    return http.post(baseUrlApi('enterprise_service/submitProxyPool'), data)
  }, index() {
    return http.post(baseUrlApi('enterprise_service/index'))
  }
}

export const document = {
  productIntroduction(data) {
    return http.post(baseUrlApi('document/productIntroduction'), data)
  }, getFaq(data) {
    return http.post(baseUrlApi('document/getFaq'), data)
  }, getDocumentList(data) {
    return http.post(baseUrlApi('document/getDocumentList'), data)
  }
}

/**
 * 配置相关
 */
export const config = {
  getHomeConfig() {
    return http.get(baseUrlApi('shop/Index/config'))
  }
}

/**
 * 首页相关接口
 */
export const index = {
  getIndex() {
    return http.get(baseUrlApi('shop/Index/getIndex'))
  }
}


export const order = {


  /**
   *
   * @param {创建订单} data
   * @returns
   */
  createOrder(data) {
    return http.post(baseUrlApi('order/createOrder'), data)
  }, /**
     *
     * @param {支付} data
     * @returns
     */
  orderPay(data) {
    return http.post(baseUrlApi('order/orderPay'), data)
  },

  /**
   * 获取订单支付状态
   * @param {} data
   * @returns
   */
  checkPayStatus(data) {
    return http.post(baseUrlApi('order/checkPayStatus'), data)
  }, /**
     *
     * @param {获取订单列表} data
     * @returns
     */
  getOrderList(data) {
    return http.post(baseUrlApi('order/getOrderList'), data)
  }, getOrderDetails(data) {
    return http.post(baseUrlApi('order/getOrderDetails'), data)
  }

}

/**
 * 充值接口
 */
export const recharge = {
  /**
   * 获取充值优惠列表
   */
  rechargeList(data) {
    return http.post(baseUrlApi('Recharge/rechargeList'), data)
  }, rechargeMoney(data) {
    return http.post(baseUrlApi('Recharge/rechargeMoney'), data)
  }, checkPayStatus(data) {
    return http.post(baseUrlApi('Recharge/checkPayStatus'), data)
  }
}


/**
 * 商品API
 */
export const goods = {

  /**
   * @returns 获取中国IP商品
   */
  getChinaIpGoods() {
    return get(baseUrlApi('Goods/getChinaIpGoods'))
  }, /**
     * 获取定制套餐
     */
  getCustomizedGoods() {
    return http.post(baseUrlApi('Goods/getCustomizedGoods'))
  },


  getCategory() {
    return http.get(baseUrlApi('Goods/getCategory'))
  }, /**
     * 获取海外商品
     */
  abroadGoods(data) {
    return http.post(baseUrlApi('Goods/abroadGoods'), data)
  },

  getAbriadIpGoodsCategory() {
    return http.post(baseUrlApi('Goods/getAbriadIpGoodsCategory'))
  }, getAbriadIpGoods(data) {
    return http.post(baseUrlApi('Goods/abroadGoods'), data)
  }, getIntroduce(data) {
    return http.post(baseUrlApi('Goods/getIntroduce'), data)
  }, getIntroduceDetail(data) {
    return http.post(baseUrlApi('Goods/getIntroduceDetail'), data)
  }


}

export const article = {
  getArticleList(data) {
    return http.post(baseUrlApi('shop/Article/getArticleList'), data)
  }
}

/**
 * 白名单接口
 */
export const whilteList = {
  getList(data) {
    return http.post(baseUrlApi('whilte_list/getList'), data)
  }, opWhilteList(data) {
    return http.post(baseUrlApi('whilte_list/opWhilteList'), data)
  }, getWhilteListLog(data) {
    return http.post(baseUrlApi('whilte_list/getWhilteListLog'), data)
  }
}


export const extractApi = {
  getApiOrder(data) {
    return http.post(baseUrlApi('extract_api/getOrder'), data)
  },

  extractUrl(data) {
    return http.post(baseUrlApi('extract_api/extractUrl'), data)
  },

  getList(data) {
    return http.post(baseUrlApi('extract_api/getList'), data)
  },

  deleteUrl(data) {
    return http.post(baseUrlApi('extract_api/deleteUrl'), data)
  },

  getDetail(data) {
    return http.post(baseUrlApi('extract_api/getDetail'), data)
  },

  getLogList(data) {
    return http.post(baseUrlApi('extract_api/getLogList'), data)
  }
}


export const RenalAuth = {
  getUserAuth(param = {}) {
    return get(baseUrlApi('renal_auth/getUserAuth'), param)
  }, getEnterpriseAuth(param = {}) {
    return get(baseUrlApi('renal_auth/getEnterpriseAuth'), param)
  },

  enterpriseAuth(param = {}) {
    return post(baseUrlApi('renal_auth/enterpriseAuth'), param)
  }, aliPersonFaceAuth(param = {}) {
    return post(baseUrlApi('renal_auth/aliPersonFaceAuth'), param)
  }, queryAuth(param = {}) {
    return get(baseUrlApi('renal_auth/queryAuth'), param)
  }


}


export const workOrder = {
  getList(param) {
    return get(baseUrlApi('work_order/getList'), param)
  }, submitWordOrder(data) {
    return post(baseUrlApi('work_order/submitWordOrder'), data)
  }, getDetail(param) {
    return get(baseUrlApi('work_order/getDetail'), param)
  },
}


export const message = {
  getList(param) {
    return get(baseUrlApi('message/getList'), param)
  }
}


export const financeLog = {
  getList(data) {
    return get(baseUrlApi('Finance_log/financeLogList'), data)
  },
}

export const packageOrder = {
  packageList(data) {
    return get(baseUrlApi('Package/packageList'), data)
  }, packageDetails(data) {
    return get(baseUrlApi('Package/packageDetails'), data)
  }, resToken(data) {
    return post(baseUrlApi('Package/resToken'), data)
  }, opWhilteList(data) {
    return post(baseUrlApi('Package/opWhilteList'), data)
  }
}

export const extract = {
  extractLogList(param) {
    return post(baseUrlApi('extract/extractLogList'), param)
  }, getArea(param) {
    return get(baseUrlApi('extract/getArea'), param)
  }, generateLink(param) {
    return post(baseUrlApi('extract/generateLink'), param)
  }


}

export const invoice = {
  submitInvoice(data) {
    return post(baseUrlApi('Invoice/submitInvoice'), data)
  },
  getList(param) {
    return get(baseUrlApi('invoice/getList'), param)
  }
}

export const awsOrder = {
  getList(param) {
    return get(baseUrlApi('aws/aws_order/list'), param)
  },
  packageDetails(data) {
    return post(baseUrlApi('aws/aws_order/packageDetails'), data)
  },
  resToken(data) {
    return post(baseUrlApi('aws/aws_order/resToken'), data)
  },
  opWhiteList(data) {
    return post(baseUrlApi('aws/aws_order/opWhilteList'), data)
  },
  extractLogList(data) {
    return post(baseUrlApi('aws/aws_order/extractLogList'), data)
  },
  getExtractUrl(data) {
    return post(baseUrlApi('aws/aws_order/getExtractUrl'), data)
  },
  getArea(data) {
    return post(baseUrlApi('aws/aws_order/getArea'), data)
  },
  generateUrl(data) {
    return post(baseUrlApi('aws/aws_order/generateUrl'), data)
  },
  getCountryList(){
     return post(baseUrlApi('aws/aws_order/getCountryList'))
  }

}







